import { SubPageLayout } from "@/components/SubPageLayout";
import { SITE_IMAGES } from "@/lib/site-data";

export default function PonyvaJavitas() {
  return (
    <SubPageLayout
      eyebrow="Ponyvajavítás"
      title="Kiszakadt? Sérült? Megoldjuk."
      intro="Teherautó-, kamion- és utánfutó ponyvák szakszerű javítása, hegesztése, átalakítása. 20+ év tapasztalat, ingyenes állapotfelmérés, garanciával végzett munka."
      heroImage="/assets/gallery/palletways-01.jpg"
      bullets={[
        { title: "Gyors beavatkozás", text: "Érkezési sorrendben." },
        { title: "Hegesztés és foltozás", text: "Szakadás, lyuk, fülpótlás, heveder, ringli – minden ponyvaprobléma." },
        { title: "Átalakítás", text: "Méretmódosítás, új tartozékok, dekoráció – egy helyen." },
        { title: "Garanciával", text: "Bízunk a munkánkban – minden javításra garanciát vállalunk." },
      ]}
      gallery={SITE_IMAGES.repairGallery}
    />
  );
}
